import React from 'react'
import PropTypes from 'prop-types'
import Loader from '@/modules/base/components/loader/loader'
import { makeStyles } from '@mui/styles'
import clsx from 'clsx'
import lang from '@/lang'

const useStyles = makeStyles(theme => ({
  root: {
    flex: 'none',
    display: 'flex',
    height: '100%',
    flexDirection: 'column',
    position: 'relative',
    width: '100%',
    backgroundColor: theme.white,
    '&.position-absolute': {
      position: 'absolute',
      top: 0,
      left: 0,
    },
  },
}))

const Panel = (props) => {
  const {
    isLoading = false,
    position = 'relative',
    className,
    children,
  } = props
  const classes = useStyles()
  return (
    <section className={clsx(classes.root, className, position && `position-${position}`)}>
      {isLoading && <Loader text={lang.generics.loaderText} visible={isLoading} />}
      {children}
    </section>
  )
}

Panel.propTypes = {
  isLoading: PropTypes.bool,
  children: PropTypes.node,
  position: PropTypes.oneOf(['relative', 'absolute']),
  className: PropTypes.string,
}

export default Panel
